import {ConfigContext} from "./contexts/config";
import { useState } from "react";

export const API_URL = process.env.REACT_APP_API_URL || 'https://node.host24.am/backend';
export const API_STATIC_URL = process.env.REACT_APP_API_STATIC_URL || `${API_URL}/static`;
export const staticUrl = (file) => (file && file !== "undefined" && file !== "null" ? `${API_STATIC_URL}${file}` : undefined);

export const ConfigProvider = ({children}) => {
    const [data, setData] = useState({
        API_URL,
        API_STATIC_URL,
        lang: 'en',
    });

    return (
        <ConfigContext.Provider value={{data, setData}}>
            {children}
        </ConfigContext.Provider>
    );
}   
